export default "__VITE_ASSET__b97a083a__"